import Block from "@mui/icons-material/Block";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Link from "@mui/material/Link";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

export const StyledDialog = styled(Dialog)({
  "& .MuiDialog-paper": {
    maxWidth: "500px",
    padding: "2rem",
    position: "relative",
  },
});

export const IconContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  marginBottom: "1rem",
});

export const StyledBlockedIcon = styled(Block)({
  fontSize: "4rem",
  color: "#1976d2",
  opacity: 0.8,
});

export const HelpLink = styled(Link)(({ theme }) => ({
  color: theme.custom?.palette.semantic.blue ?? theme.palette.primary.main,
}));

export const Title = styled(Typography)({
  textAlign: "center",
  fontSize: "1.5rem",
  fontWeight: 600,
  marginBottom: "0.75rem",
});

export const Message = styled(Typography)({
  textAlign: "center",
  color: "#666",
  marginBottom: "1.5rem",
  fontSize: "0.95rem",
  lineHeight: 1.6,
});

export const ButtonContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
});
